import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSeo } from "../hooks/useSeo";
import { OrangeButton } from "../components/blocks";

const KEY_LINKS = [
  { label: "Home", to: "/" },
  { label: "Founder Network", to: "/founder-network" },
  { label: "Podcast", to: "/the-intuitive-leader-podcast" },
  { label: "Free Webinars", to: "/how-to-develop-intuition-in-business" },
  { label: "Blog", to: "/blog" },
  { label: "About Maurice", to: "/about-maurice-jenkens" },
];

export default function NotFound() {
  const navigate = useNavigate();
  useSeo(
    "Page not found | The Intuitive Leader",
    "The page you were looking for could not be found. Explore The Intuitive Leader — intuition coaching, podcast and founder network by Maurice Jenkens.",
    { noindex: true }
  );

  return (
    <section className="bg-ink min-h-[70vh] px-6 sm:px-10 py-32 flex items-center" data-testid="notfound-page">
      <div className="max-w-2xl mx-auto text-center">
        <p className="font-display text-7xl sm:text-8xl text-ember" data-testid="notfound-code">404</p>
        <h1 className="font-h1 text-3xl sm:text-4xl text-white mt-6 leading-tight">This page trusted the wrong path.</h1>
        <p className="text-white text-base mt-5 max-w-lg mx-auto">
          The page you were looking for doesn't exist or has moved. Let's get you back on track.
        </p>

        <div className="mt-9 flex justify-center">
          <OrangeButton onClick={() => navigate("/")} testid="notfound-home-btn">Back to home</OrangeButton>
        </div>

        <div className="mt-12">
          <p className="font-eyebrow text-white text-xs mb-5">Popular pages</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {KEY_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-white hover:text-embersoft text-[15px] transition-colors"
                data-testid={`notfound-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
